export default [
  {
    path: "/availability/inquiry",
    name: "InquiryAvailabilityResult",
    component: () => import("@/components/availability/result/inquiry/Result"),
    meta: {
      requiresAuth: true,
      services: ["InquiryAvailability"]
    }
  },
  {
    path: "/availability/instant",
    name: "InstantAvailabilityResult",
    component: () => import("@/components/availability/result/instant/Result"),
    meta: {
      requiresAuth: true,
      services: ["InstantAvailability"]
    }
  },
  {
    path: "/form/instant/:id",
    name: "InstantReservationForm",
    component: () => import("@/components/reservation/instant/ReservationForm"),
    meta: {
      requiresAuth: true,
      services: ["InstantAvailability"]
    }
  },
  {
    path: "/form/inquiry/:id",
    name: "InquiryReservationForm",
    component: () => import("@/components/reservation/inquiry/ReservationForm"),
    meta: {
      requiresAuth: true,
      services: ["InquiryAvailability"]
    }
  },
  {
    path: "/form/inquiry-rental/:id",
    name: "InquiryReservationFormRental",
    component: () =>
      import("@/components/reservation/inquiry/ReservationFormRental"),
    meta: {
      requiresAuth: true,
      services: ["InquiryAvailability"]
    }
  },
  {
    path: "/reservation/instant/:id",
    name: "InstantReservationSummary",
    component: () =>
      import("@/components/reservation/instant/ReservationSummary"),
    meta: {
      requiresAuth: true,
      services: ["InstantAvailability", "InstantReservation"]
    }
  },
  {
    path: "/reservation/inquiry/:id",
    name: "InquiryReservationSummary",
    component: () =>
      import("@/components/reservation/inquiry/ReservationSummary"),
    meta: {
      requiresAuth: true,
      services: ["InquiryAvailability", "InquiryReservation"]
    }
  },
  {
    path: "/reservation/tenant/trip-log/:id",
    name: "InquiryReservationLogging",
    component: () =>
      import("@/components/reservation/inquiry/ReservationLogging"),
    meta: {
      requiresAuth: true,
      services: ["InquiryAvailability", "InquiryReservation"]
    }
  },
  {
    path: "/reservation/provider/trip-log/:id",
    name: "InquiryReservationLogging",
    component: () =>
      import("@/components/reservation/inquiry/ReservationLogging"),
    meta: {
      requiresAuth: true,
      services: ["InquiryAvailability", "InquiryReservation"]
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/shoppingModule.js